import React from 'react';

export default function Footer() {
  const year = (new Date()).toString().split(' ')[3];
  return (
    <footer className="pad-top-10 pad-bottom-10 text-center">
      ©{year} American Family Insurance. All rights reserved.
    </footer>
  );
}
